import React from 'react';
import { Link } from 'react-router-dom';
import styles from './NotFoundPage.module.css';

const NotFoundPage = () => {
  return (
    <div className="container">
      <div className="card">
        <div className={styles.notFound}>
          <h1>404 - Seite nicht gefunden</h1>
          <p>Die Seite, die du suchst, existiert nicht.</p>
          <div className={styles.actions}>
            <Link to="/" className="btn btn-primary">
              Zur Startseite
            </Link>
            <Link to="/create" className="btn btn-primary">
              Create Secret
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;